(() => {
  const drawer = document.querySelector('[data-avant-cart-drawer]');
  if (!drawer || drawer.dataset.ready === 'true') return;
  drawer.dataset.ready = 'true';
  const routes = Object.assign({ cart_url: '/cart', cart_add_url: '/cart/add', cart_change_url: '/cart/change' }, window.routes || {});
  let returnFocus = null;
  let hideTimer = null;

  const announce = (message) => {
    const status = drawer.querySelector('[data-avant-cart-status]');
    if (status) status.textContent = message;
  };
  const updateBadges = (count) => {
    document.querySelectorAll('[data-avant-cart-count]').forEach((badge) => {
      const headerBadge = badge.classList.contains('avant-global-header__cart-count');
      const drawerLabel = Boolean(badge.closest('.avant-cart-drawer__header'));
      badge.textContent = drawerLabel ? `(${count})` : String(count);
      if (headerBadge) badge.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-avant-cart-open]').forEach((opener) => {
      opener.setAttribute('aria-label', `View cart, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  };
  const open = (trigger) => {
    window.clearTimeout(hideTimer);
    returnFocus = trigger || returnFocus;
    drawer.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('avant-cart-is-open');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.querySelector('[data-avant-cart-close]')?.focus();
  };
  const close = () => {
    window.clearTimeout(hideTimer);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('avant-cart-is-open');
    hideTimer = window.setTimeout(() => drawer.setAttribute('hidden', ''), 450);
    returnFocus?.focus();
  };
  const refresh = async ({ open: shouldOpen = false, trigger = null } = {}) => {
    const pageRequest = fetch(window.location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Unable to refresh the cart.');
    const cart = await cartResponse.json();
    updateBadges(cart.item_count || 0);
    if (shouldOpen) open(trigger);
    document.dispatchEvent(new CustomEvent('avant:cart-updated', { detail: { cart } }));

    const pageResponse = await pageRequest;
    if (pageResponse.ok) {
      const parsedPage = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');
      const freshDrawer = parsedPage.querySelector('[data-avant-cart-drawer]');
      if (freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
      if (shouldOpen) open(trigger);
    }
    return cart;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.ajaxCart === 'false') return;
    event.preventDefault();
    const submit = event.submitter || form.querySelector('[type="submit"]');
    const label = submit?.querySelector('[data-add-label]');
    const originalLabel = label?.textContent;
    if (submit) submit.disabled = true;
    if (label) label.textContent = 'Adding…';
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added.');
      const status = form.querySelector('[data-cart-status]');
      if (status) status.textContent = 'Added to your cart.';
      await refresh({ open: true, trigger: submit });
      announce('Item added to your cart.');
    } catch (error) {
      const status = form.querySelector('[data-cart-status]');
      if (status) status.textContent = error.message;
      announce(error.message);
    } finally {
      if (submit) submit.disabled = false;
      if (label && originalLabel) label.textContent = originalLabel;
      form.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-avant-cart-open]');
    if (opener) { event.preventDefault(); open(opener); return; }
    if (event.target.closest('[data-avant-cart-close]')) { close(); return; }
    const removeButton = event.target.closest('[data-avant-cart-remove]');
    if (!removeButton) return;
    event.preventDefault();
    removeButton.disabled = true;
    try {
      const response = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: removeButton.dataset.avantCartRemove, quantity: 0 }),
      });
      if (!response.ok) throw new Error('Unable to remove this item.');
      await refresh({ open: true });
      announce('Item removed from your cart.');
    } catch (error) { removeButton.disabled = false; announce(error.message); }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  drawer.setAttribute('hidden', '');
  window.AvantCart = { open, close, refresh, updateBadges };
})();
